import React from 'react';

import { INotificationGridItem } from '../notification-grid';

import { DetailsRow } from './DetailsRow';
import { LeadInfo } from './utils';

export const WithdrawRequestAttemptDetails: React.FC<INotificationGridItem> = ({
  date,
  notificationDetails: { data },
}) => (
  <>
    <DetailsRow label="Date" value={date} />
    <DetailsRow
      label="Client ID"
      component={<LeadInfo leadId={data.leadId} />}
    />
    <DetailsRow label="Name" value={data.leadFullName} />
    <DetailsRow label="Amount" value={`${data.amount} ${data.currency}`} />
    <DetailsRow label="Manager ID" value={data.managerId} />
    <DetailsRow label="Manager" value={data.managerName} />
    <DetailsRow label="Comment" value={data.comment} />
  </>
);
